@import '../../style/index';

:host {
  display: block;
  margin-bottom: var(--spacings-s);

  .toggle-wrapper {
    display: flex;
    align-items: center;
    width: fit-content;
  }

  .toggle {
    height: 0;
    width: 0;
    visibility: hidden;

    &__switcher {
      cursor: pointer;
      width: rem-calc(48px);
      height: rem-calc(24px);
      background: grey;
      border-radius: rem-calc(100px);
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        top: rem-calc(3px);
        left: rem-calc(3px);
        width: rem-calc(18px);
        height: rem-calc(18px);
        background: #fff;
        border-radius: rem-calc(90px);
        transition: 0.3s;
      }

      &:active::after {
        width: 21px;
      }
    }

    &__label {
      vertical-align: super;
      font-family: $font-family-semibold;
      font-size: rem-calc(16px);
      color: var(--colors-basic-white);
      margin-left: var(--spacings-s);
    }

    &__skip-link {
      color: #4c4c4c !important;
    }
  }

  .toggle:checked + .toggle__switcher {
    background: #92d050;
  }

  .toggle:checked + .toggle__switcher::after {
    left: calc(100% - #{(rem-calc(3px))});
    transform: translateX(-100%);
  }
}
